var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-50 sticky lg:fixed bottom-0 left-0 right-0 lg:grid lg:grid-cols-3"},[_c('div',{staticClass:"bg-white lg:col-span-2 flex border-t border-gray-200 justify-between py-8 lg:mx-14"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }